/**
 * Phase 2 (LLM) — invoke artifact-contracts discover --write.
 */

import { spawn } from "node:child_process";

export interface DiscoverResult {
  success: boolean;
  exitCode: number | null;
  stdout: string;
  stderr: string;
}

export async function runArtifactDiscover(projectRoot: string): Promise<DiscoverResult> {
  return new Promise((resolvePromise) => {
    const stdoutChunks: string[] = [];
    const stderrChunks: string[] = [];

    const child = spawn(
      "npx",
      ["artifact-contracts", "discover", "--write"],
      {
        cwd: projectRoot,
        stdio: ["ignore", "pipe", "pipe"],
        shell: process.platform === "win32",
      },
    );

    child.stdout?.on("data", (chunk: Buffer) => stdoutChunks.push(chunk.toString()));
    child.stderr?.on("data", (chunk: Buffer) => stderrChunks.push(chunk.toString()));

    child.on("close", (code) => {
      resolvePromise({
        success: code === 0,
        exitCode: code,
        stdout: stdoutChunks.join(""),
        stderr: stderrChunks.join(""),
      });
    });

    child.on("error", (err) => {
      resolvePromise({
        success: false,
        exitCode: null,
        stdout: stdoutChunks.join(""),
        stderr: err.message,
      });
    });
  });
}
